import routes from '@routes';
import React from 'react';
import getParseUrl from '@utils/helpers/parse-url';

interface PostItemSchemaProps {
  slug: string
  publishedAt: string
  image: string
  author?: string
}

const PostItemSchema = ({ slug, publishedAt, image, author }: PostItemSchemaProps) => {
  return (
    <>
      <meta itemProp="author" content={author || 'پزشک بوک'}/>
      <meta itemProp="mainEntityOfPage" content={process.env.APP_SITE_URL_WITH_HTTP}/>
      <span itemProp="publisher" itemScope itemType="https://schema.org/Organization">
        <meta itemProp="name" content="PezeshkBook"/>
        <span itemProp="logo" itemScope itemType="https://schema.org/ImageObject">
          <meta itemProp="url" content={`${process.env.APP_SITE_URL_WITH_HTTP}/brand-icons/icon-72x72.png`}/>
        </span>
        <meta itemProp="url" content={process.env.APP_SITE_URL_WITH_HTTP}/>
      </span>
      <meta itemProp="datePublished" content={publishedAt}/>
      <meta itemProp="dateModified" content={publishedAt}/>
      <span itemProp="image" itemScope itemType="https://schema.org/ImageObject">
        <meta itemProp="url" content={image}/>
        <meta itemProp="height" content="480"/>
        <meta itemProp="width" content="720"/>
      </span>
      <meta itemProp="url" content={`${process.env.APP_SITE_URL_WITH_HTTP}${getParseUrl({ pathname: routes['route.posts.show'], query: { slug: slug } })}`}/>
    </>
  );
};

export default PostItemSchema;
